// extracted by mini-css-extract-plugin
module.exports = {"price_grid":"jumbo-module--price_grid--3mEZ-"};